/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ab_Otp_H2Inputs */

const es_ab_otp_h2 = /** @type {(inputs: Ab_Otp_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa tu correo`)
};

const gl_ab_otp_h2 = /** @type {(inputs: Ab_Otp_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisa o teu correo`)
};

const en_ab_otp_h2 = /** @type {(inputs: Ab_Otp_H2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Check your email`)
};

/**
* | output |
* | --- |
* | "Check your email" |
*
* @param {Ab_Otp_H2Inputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const ab_otp_h2 = /** @type {((inputs?: Ab_Otp_H2Inputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ab_Otp_H2Inputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_ab_otp_h2(inputs)
	if (locale === "en") return en_ab_otp_h2(inputs)
	return es_ab_otp_h2(inputs)
});